import axios from "./index";
import {
    wxAuthBase
} from "../utils/wxUtils";
import {
    Indicator,
    Toast
} from "mint-ui";
import store from "../store";
import {
    baseUrl
} from "../config/CONSTANTS";
import router from "@/router";
import {
    MessageBox
} from "mint-ui";

let dev = window.navigator.userAgent
    .toLocaleLowerCase()
    .match(/MicroMessenger/i);
if (dev && dev[0] === "micromessenger") {
    //     store.commit('CLIENT',0);
    // } else {
    //     store.commit('CLIENT',1);
}
var isloading = true;
export const fetch = (options) => {
    var client = store.state.client;

    if (options["headers"] && options["headers"]["noloading"]) {
        isloading = false;
    }
    if (options.data) {
        if (options.data.mask == 0) {} else {
            if (isloading) {
                Indicator.open({
                    spinnerType: "fading-circle",
                    text: "加载中...",
                });
                isloading = false;
            }
        }
    } else if (options.params) {
        if (options.params.mask == 0) {} else {
            if (isloading) {
                Indicator.open({
                    spinnerType: "fading-circle",
                    text: "加载中...",
                });
                isloading = false;
            }
        }
    } else {
        if (isloading) {
            Indicator.open({
                spinnerType: "fading-circle",
                text: "加载中..."
            });
            isloading = false;
        }
    }

    return new Promise((resolve, reject) => {
        const instance = axios.create({});
        //options.withCredentials=true;
        instance(options)
            .then((response) => {
                  let res=response.data;
                  Indicator.close();

                 if(res.code === 4005) {
                    if (process.env.NODE_ENV == "development") {
                        $.ajax({
                            url: baseUrl + "/user/user/token?id=2",
                            type: "get",
                            success: function(res) {
                                let data = res.data;
                                localStorage.setItem("token", data.token);
                                localStorage.setItem("avatar", data.avatar);
                                localStorage.setItem("nick_name", data.nick_name);
                                window.location.reload();
                            },
                        });
                    }else{
                        wxAuthBase(location.pathname + location.search);
                    }
                }else if(res.code==200){
                       resolve(res.data);
                }else{
                     
                        MessageBox({message: res.msg,type: 'warning'})
                        //如果header中有accept_error,则服务端返回错误时会在catch中接收到
                        if(options["headers"] && options["headers"]["accept_error"]){
                            reject(res.msg);
                        }
                }     
                }).catch((error) => {
                console.log("请求异常信息：" + error);
                setTimeout((isloading = true), 500);
                reject(error);
                Indicator.close();
                // Indicator.close();
            });
    });

};

export default fetch;


// WEBPACK FOOTER //
// ./src/axios/fetch.js